export enum CaseStage {
  initialReview = 'Initial Review',
  outreach = 'Outreach',
}
